import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  active: undefined,
  view: 'day'
}

const eventsMenu = createSlice({
  name: 'events_menu',
  initialState,
  reducers: {
    selectEventsMenuItem (state, action) {
      return {
        ...state,
        active: action.payload
      }
    },
    selectEventView (state, action) {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

const persistConfig = {
  key: 'events_menu',
  storage
}

export const { selectEventsMenuItem, selectEventView } = eventsMenu.actions
export const EventsMenuReducer = persistReducer(
  persistConfig,
  eventsMenu.reducer
)
